const breakpoints = {
  s: '(min-width: 580px)',
  m: '(min-width: 960px)',
  l: '(min-width: 1340px)'
};

const MediaQueryDirective = (
  _el,
  { modifiers, expression },
  { evaluateLater, cleanup }
) => {
  const evaluate = evaluateLater(expression);

  const queries = modifiers
    ? modifiers.map((m) => breakpoints[m])
    : Object.values(breakpoints);

  const mediaQueries = queries.map((q) => window.matchMedia(q));

  const onChange = (e) =>
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    evaluate(() => {}, { scope: { $matches: e.matches } });

  mediaQueries.forEach((mq) => {
    mq.addEventListener('change', onChange);
    onChange(mq);
  });

  cleanup(() => {
    mediaQueries.forEach((mq) => {
      mq.removeEventListener('change', onChange);
    });
  });
};

export default MediaQueryDirective;
